import * as React from 'react';
import { ContentRow } from '../../../components/ContentRow';
import { Button, FormFieldInput, Header2, Paragraph2 } from '@cian/ui-kit';
import { Formik } from 'formik';

interface IComplaintFeedbackContainerProps {
  feedbackRequired: boolean;
  initialEmail?: string;
  onSubmit(email: string): void;
  onClose(): void;
}

const EMAIL_MASK = /^.+@.+\.[a-zа-яё]+$/;
const MAX_EMAIL_LENGTH = 254;
const INVALIDE_EMAIL_ERROR_MESSAGE = 'Некорректный "E-mail"';
const LONG_EMAIL_ERROR = 'E-mail не может быть более 254 символов';

export function ComplaintFeedbackContainer({
  feedbackRequired,
  initialEmail,
  onSubmit,
  onClose,
}: IComplaintFeedbackContainerProps) {
  const handleValidateForm = (values: { email: string }) => {
    if (!values.email) {
      return { email: 'Введите email' };
    }

    if (values.email.length > MAX_EMAIL_LENGTH) {
      return { email: LONG_EMAIL_ERROR };
    }

    if (!EMAIL_MASK.test(values.email)) {
      return {
        email: INVALIDE_EMAIL_ERROR_MESSAGE,
      };
    }

    return {};
  };

  return (
    <ContentRow>
      <ContentRow size="M">
        <Header2>✅ Спасибо за помощь. Жалоба принята к рассмотрению.</Header2>
      </ContentRow>
      {feedbackRequired && (
        <ContentRow>
          <ContentRow>
            <Paragraph2>
              Вы можете оставить ваш e-mail, и мы пришлем вам информацию о нашем решении по рассмотрению жалобы в случае
              подтверждения нарушения правил
            </Paragraph2>
            <Formik
              initialValues={{ email: initialEmail || '' }}
              onSubmit={({ email }) => onSubmit(email)}
              validate={handleValidateForm}
            >
              {props => {
                return (
                  <form onSubmit={props.handleSubmit}>
                    <ContentRow size="M">
                      <FormFieldInput
                        label="Email"
                        name="email"
                        errorMessage={props.errors.email}
                        value={props.values.email}
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                    </ContentRow>

                    <Button size="XS" theme="fill_primary" type="submit">
                      Отправить
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </ContentRow>
        </ContentRow>
      )}
      {!feedbackRequired && (
        <Button theme="fill_primary" onClick={onClose} size="XS">
          Закрыть
        </Button>
      )}
    </ContentRow>
  );
}
